import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { TESTIMONIALS } from "../../data/content";

export const Testimonials = () => {
  return (
    <section id="opiniones" data-testid="testimonials-section" className="bg-[#F9FAF8] py-24 md:py-32 border-t border-black/5">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16 items-end">
          <div className="md:col-span-8">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#5AB82D]">
              Opiniones verificadas
            </span>
            <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl md:text-6xl font-medium tracking-tight text-[#0A1F10] leading-[1.05]">
              Lo que dicen tus vecinos de Huelva
            </h2>
          </div>
          <div className="md:col-span-4 md:text-right">
            <div className="inline-flex flex-col items-start md:items-end">
              <div className="flex items-center gap-1">
                <span className="font-serif-display text-5xl font-semibold text-[#0A1F10]">5.0</span>
                <div className="flex flex-col">
                  <div className="flex">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-[#5AB82D] text-[#5AB82D]" />
                    ))}
                  </div>
                  <span className="text-xs font-semibold text-[#4B5E51]">22 reseñas en Google</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.1 }}
              className="relative bg-white rounded-sm p-8 md:p-10 border border-black/5 shadow-[0_10px_40px_-24px_rgba(10,31,16,0.3)]"
              data-testid={`testimonial-${i}`}
            >
              <span className="font-serif-display absolute top-2 right-6 text-7xl text-[#5AB82D]/15 leading-none select-none">”</span>
              <div className="flex mb-5">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-[#5AB82D] text-[#5AB82D]" />
                ))}
              </div>
              <p className="font-serif-display text-xl md:text-2xl leading-snug text-[#0A1F10] mb-6 relative z-10">
                {t.text}
              </p>
              <footer className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#EBF6E4] flex items-center justify-center font-bold text-[#2E5A1B]">
                  {t.author.charAt(0).toUpperCase()}
                </div>
                <div>
                  <cite className="not-italic block text-sm font-bold text-[#0A1F10]">{t.author}</cite>
                  <span className="text-xs text-[#4B5E51]">{t.role}</span>
                </div>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
